import React, { useState } from 'react';
import {  Table, Modal, Button, Input, Typography, Space, message, Spin, Select } from 'antd';
import AssessmentPage from './AssessmentPage';
import { useAppContext } from './AppContext';
import EmployeeTree from './EmployeeHierarchy';
import { useEffect } from 'react';
import { directReportsURL, employeesURL } from '../Config';


const { Text } = Typography;
const { Search } = Input;
const { Option } = Select;

const ListOfEmployee = () => {
  const [sortedInfo, setSortedInfo] = useState({});
  const { filteredTableData, setFilteredTableData } = useAppContext();
  const { reportType, setReportType } = useAppContext();
  const { tableData, setTableData } = useAppContext();
  const { AdvanceFilter, upName,isAdmin,idToken } = useAppContext();
  const [filteredInfo, setFilteredInfo] = useState({});
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [rankingChanges, setRankingChanges] = useState({});
  const [saveTimeout, setSaveTimeout] = useState(null);
  const [pendingSave, setPendingSave] = useState(false);
  const [pagination, setPagination] = useState({ pageSize: 5, current: 1 });
  const [empSearchValue, setEmpSearchValue] = useState('');
  const [managerSearchValue, setManagerSearchValue] = useState('');
  const [jobLevelSearchValue, setJobLevelSearchValue] = useState('');
  const [locationSearchValue, setLocationSearchValue] = useState('');

  const nineboxMappingOrder = {
    "Poor Fit": 1,
    "Needs Performance Management": 2,
    "Needs Improvement": 3,
    "Suitably Placed": 4,
    "Solid Performer": 5,
    "Valued Professional": 6,
    "Expandable": 7,
    "Promotable": 8,
    "Top Talent": 9
  };

  message.config({
    className: 'ant-message-custom-content',
    duration: 3, // Adjust the duration as needed
  })

  //*****************Column search*********************/

  const handleRefresh = () => {
    //console.log('Refresh Flag before toggle:', refreshFlag);
  setRefreshFlag(prevFlag => !prevFlag);
  //console.log('Refresh Flag after toggle:', !refreshFlag);
  };

  useEffect(() => {

    setEmpSearchValue('');
    setManagerSearchValue('');
    setJobLevelSearchValue('');
    setLocationSearchValue('');

    AdvanceFilter('userName', '');
    AdvanceFilter('managerName', '');
    AdvanceFilter('jobLevel', '');
    AdvanceFilter('location', '');

    const fetchData = async () => {
      setLoading(true);
      //console.log('Fetching data for:', upName);
      setTableData([]);
      
      try {
        const requestData = {
          userId: upName
        };

        //console.log(directReportsURL);
        //console.log(requestData);
        //console.log(idToken);

        const response = await fetch(directReportsURL+ `/${upName}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });
                
        
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const data = await response.json();
        //console.log('Data fetched successfully:', data);
        setTableData(data);
        setReportType('Direct Reports');
        
        const directReportsData = data.filter(item => 
          item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
        );
        
        setFilteredTableData(directReportsData);
      } catch (error) {
        //console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
    handleReportChange('Direct Reports');
  }, [upName, refreshFlag]);
  



  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    setFilteredInfo(filters);
    setPagination({
      ...pagination,
      pageSize: pagination.pageSize, // Update pageSize dynamically
    });
  };

  const handleRankChange = (key, newRank, rankType) => {
    //console.log('Key:', key);
    //console.log('New Rank:', newRank);
    //console.log('Rank Type:', rankType);

    const updateData = (item) => {
      if (item.key === key) {
        if (rankType === 'ELT') {
          return { ...item, eltRanking: newRank };
        } else {
          return { ...item, overallRanking: newRank };
        }
      }
      return item;
    };

    setFilteredTableData(prevData => {
      const newData = prevData.map(updateData);
      //console.log('Updated Data:', newData);
      return newData;
    });;

    if (saveTimeout) {
      clearTimeout(saveTimeout);
    }

    setPendingSave(true);
  };

  useEffect(() => {
    if (pendingSave) {
      //console.log('handleRankChange filteredTableData:', filteredTableData);

      
      // Delay the save operation to debounce rapid changes
      const timeout = setTimeout(() => {
        setPendingSave(false);
        handleSave();
      }, 10000);
  
      setSaveTimeout(timeout);
  
      // Cleanup the timeout if the component unmounts or if handleSave is called again before the timeout completes
      return () => clearTimeout(timeout);
    }
  }, [filteredTableData, pendingSave]);

  const columns = [

    {
      title: <strong>Emp Name</strong>,
      dataIndex: 'userName',
      key: 'userName',
      fixed: 'left',
      width: 250,
      onCell: (record) => ({
        onClick: () => showModal(record),
      }),
      sorter: (a, b) => a.userName.localeCompare(b.userName),

      render: (text) => (
        <span style={{ fontWeight: 'bold', color: '#3498DB', cursor: 'pointer' }}  >
          {text}
        </span>
      )
    },
    {
      title: <strong>Hire Date</strong>,
      dataIndex: 'hireDate',
      key: 'hireDate',
      width: 150,
      sorter: (a, b) => a.hireDate.localeCompare(b.hireDate),
      render: (text) => {
        // Parse the date string
        const date = new Date(text);
        // Options for formatting the date
        const options = { day: '2-digit', month: 'short', year: '2-digit' };
        // Format the date using options
        const formattedDate = date.toLocaleDateString('en-US', options);
        // Return the formatted date
        return formattedDate;
      },
    },
    {
      title: <strong>Tenure</strong>,
      dataIndex: 'tenure',
      key: 'tenure',
      sorter: (a, b) => a.tenure - b.tenure,
      render: (text) => {
        return text + ' years';
      }
    },
    {
      title: <strong>Job Title</strong>,
      dataIndex: 'jobTitle',
      key: 'jobTitle',
      width: 250,
      sorter: (a, b) => a.jobTitle.localeCompare(b.jobTitle),
    },
    {
      title: <strong>Job Level</strong>,
      dataIndex: 'jobLevel',
      key: 'jobLevel',
      sorter: (a, b) => a.jobLevel.localeCompare(b.jobLevel),
    },
    {
      title: <strong>Manager Name</strong>,
      dataIndex: 'managerName',
      key: 'managerName',
      width: 250,
      sorter: (a, b) => a.managerName.localeCompare(b.managerName),

    },
    {
      title: <strong>Performance Rating</strong>,
      dataIndex: 'performancerating',
      key: 'performancerating',
      width: 250,
      sorter: (a, b) => a.performancerating.localeCompare(b.performancerating),
    },
    {
      title: <strong>Potential Rating</strong>,
      dataIndex: 'potentialrating',
      key: 'potentialrating',
      width: 250,
      sorter: (a, b) => a.potentialrating.localeCompare(b.potentialrating),
    },
    /* {
      title: <strong>Pontential Rating Score</strong>,
      dataIndex: 'potentialRatingScore',
      key: 'potentialRatingScore',
      sorter: (a, b) => a.potentialRatingScore - b.potentialRatingScore
    }, */
    {
      title: <strong>9 Box Mapping</strong>,
      dataIndex: 'nineboxmapping',
      key: 'nineboxmapping',
      width: 250,
      sorter: (a, b) => {
        // Use the mapping to sort by numerical value
        return (
          (nineboxMappingOrder[a.nineboxmapping] || 0) - 
          (nineboxMappingOrder[b.nineboxmapping] || 0)
        );
      },
      render: (text) => {
        let color;
        let backgroundColor;
        if (text === 'Poor Fit' || text === 'Needs Performance Management' || text === 'Needs Improvement') {
          color = '#C51E1E';
          backgroundColor = '#F9ECEC';
        } else if (text === 'Promotable' || text === 'Expandable' || text === 'Top Talent') {
          color = '#008000';
          backgroundColor = '#DCF3D9';
        }
        else if (text === 'Suitably Placed' || text === 'Solid Performer' || text === 'Valued Professional') {
          color = '#D68910';
          backgroundColor = '#FCF3CF';
        }
        else {
          color = 'black';
        }

        return <span style={{ backgroundColor, color, fontWeight: 'bold', padding: '8px', borderRadius: '8px', fontSize: '16px', marginLeft: '10px' }}>{text}</span>;
      }
    },
    {
      title: <strong>ELT Ranking</strong>,
      dataIndex: 'eltRanking',
      key: 'eltRanking',
      fixed: 'right',
      width: 100,
      render: (text, record) => {

        return (
          <Input defaultValue={text ? text.toString() : ''} onChange={(e) => handleRankChange(record.key, parseInt(e.target.value), 'ELT')} />
        )
      },
      sorter: (a, b) => {
        // Handle empty values separately
        if (!a.eltRanking && !b.eltRanking) {
          return 0; // If both values are empty, consider them equal
        } else if (!a.eltRanking) {
          return 1; // Empty value should go at the end
        } else if (!b.eltRanking) {
          return -1; // Empty value should go at the end
        } else {
          return a.eltRanking - b.eltRanking; // Normal sorting for non-empty values
        }
      },
      defaultSortOrder: 'ascend'
    },
    {
      title: <strong>Overall Ranking</strong>,
      dataIndex: 'overallRanking',
      key: 'overallRanking',
      fixed: 'right',
      width: 100,
      render: (text, record) => {

        return (
          <Input defaultValue={text ? text.toString() : ''} onChange={(e) => handleRankChange(record.key, parseInt(e.target.value), 'OVERALL')} />
        )
      },
      sorter: (a, b) => {
        // Handle empty values separately
        if (!a.overallRanking && !b.overallRanking) {
          return 0; // If both values are empty, consider them equal
        } else if (!a.overallRanking) {
          return 1; // Empty value should go at the end
        } else if (!b.overallRanking) {
          return -1; // Empty value should go at the end
        } else {
          return a.overallRanking - b.overallRanking; // Normal sorting for non-empty values
        }
      },
    }
  ];

  if(isAdmin){
    columns.splice(8,0,{
      title: <strong>Pontential Rating Score</strong>,
      dataIndex: 'potentialRatingScore',
      key: 'potentialRatingScore',
      sorter: (a, b) => a.potentialRatingScore - b.potentialRatingScore
    })}

  const tableStyle = {
    border: '1px solid #d9d9d9', // Set the border style
  };


  const [modalVisible, setModalVisible] = useState(false);



  const showModal = (record) => {
    //console.log(record.userName);
    setSelectedData(record);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const calculateModalWidth = () => {
    // Calculate 75% of the parent window width
    const parentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return Math.round((parentWidth * 0.90) / 100) * 100; // Round to the nearest 100 pixels
  };

  const [filters, setFilters] = useState({ managerName: '' });

  const handleFilterChange = (filterType, value) => {
    setFilters({ ...filters, [filterType]: value });
    const filteredResults = filteredTableData.filter(item => {
      return (
        item.managerName.toLowerCase().includes(filters.managerName.toLowerCase())

      );
    });
    AdvanceFilter(filterType, value);
  };

  const handleReportChange = (value) => {

    if (value === 'Direct Reports') {
      setReportType('Direct Reports');
      const filteredResults = tableData.filter(item => {
        return (
          item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
        );
      });
      setFilteredTableData(filteredResults);
    }
    else if (value === 'Indirect Reports') {
      setReportType('Indirect Reports');
      const filteredResults = tableData.filter(item => {
        return (
          item.managerEmail && item.managerEmail.toString().toLowerCase() !== upName.toString().toLowerCase()
        );
      });
      setFilteredTableData(filteredResults);
    }
    else {
      setReportType('All Employees');
      setFilteredTableData(tableData);
    }
  }



  const handleSave = () => {

    //console.log('Filtered Table Data:', filteredTableData);

    const changedData = filteredTableData.map(row => {
      // Convert eltRanking to string before sending
      const eltRankingAsString = String(row.eltRanking);
      const overallRankingAsString = String(row.overallRanking);
      // Map to include only eltRanking and overallRanking fields
      return {
        userEmail: row.userEmail,
        userPrincipalName: row.userPrincipalName,
        eltRanking: eltRankingAsString,
        overallRanking: overallRankingAsString
      };
    });

    //console.log('Changed data:', changedData);

    fetch(employeesURL + '/list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(changedData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to save data');
        }

        return response.json();

      })
      .then(data => {

        //console.log('Data saved successfully:', data);
        handleRefresh();
      })
      .catch(error => {
        //console.error('Error saving data:', error);
        handleRefresh();
      });

    message.success("Saved");

   
  };


  return (

    <div>
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <Space >
          <Select value={reportType} defaultValue="Direct Reports" style={{ width: 150 }} onChange={handleReportChange}>
            <Option value="Direct Reports">Direct Reports</Option>
            <Option value="Indirect Reports">Indirect Reports</Option>
            <Option value="All Employees">All Employees</Option>
          </Select>
          <Search
            placeholder="Employee"
            value={empSearchValue}
            onChange={e => setEmpSearchValue(e.target.value)}
            onSearch={value => handleFilterChange('userName', value)} />
          <Search
            placeholder="Manager"
            value={managerSearchValue}
            onChange={e => setManagerSearchValue(e.target.value)}
            onSearch={value => handleFilterChange('managerName', value)} />          
          <Search
            placeholder="Job Level"
            value={jobLevelSearchValue}
            onChange={e => setJobLevelSearchValue(e.target.value)}
            onSearch={value =>  handleFilterChange('jobLevel', value)} />          
          <Search
            placeholder="Location"
            value={locationSearchValue}
            onChange={e => setLocationSearchValue(e.target.value)}
            onSearch={value =>  handleFilterChange('location', value)} />

          <Button style={{marginRight:10, marginLeft:20}} onClick={handleRefresh} type="primary">Refresh</Button>        
          <Button onClick={handleSave} type="primary">Save</Button>
        </Space>
        
        
        
      </div>
      <div style={{ margin: 10 }}>
        <Spin size="large" spinning={loading}>
          <Table
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              pageSizeOptions: ['5', '10', '15','20','50','100'],
              showSizeChanger: true,
            }}
            columns={columns}
            scroll={{ x: true }}
            dataSource={filteredTableData}
            style={tableStyle}
            filteredInfo={filteredInfo}
            onChange={handleChange}
          />
        </Spin>
      </div>
      <Modal
        style={{ top: 5 }}
        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={calculateModalWidth()}
      >

        <div>
          <EmployeeTree clickable={false} />
          <br />
          <AssessmentPage data={selectedData} handleRefresh={handleRefresh} />
        </div>

      </Modal>
    </div>

  );
};

export default ListOfEmployee;